import { forwardRef, useCallback } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useLang, withLang } from "./LangContext";

/**
 * <LocalizedLink to="/games"> — renders <Link> with the current language prefix.
 * Passes through all Link props.
 */
export const LocalizedLink = forwardRef(function LocalizedLink({ to, ...rest }, ref) {
  const { lang } = useLang();
  const target = withLang(lang, to);
  return <Link ref={ref} to={target} {...rest} />;
});

/**
 * <LocalizedNavLink> — same as LocalizedLink but uses NavLink for active styling.
 */
export const LocalizedNavLink = forwardRef(function LocalizedNavLink({ to, ...rest }, ref) {
  const { lang } = useLang();
  const target = withLang(lang, to);
  return <NavLink ref={ref} to={target} {...rest} />;
});

/**
 * useLocalizedNav — returns a function like useNavigate() but prefixed with current language.
 */
export function useLocalizedNav() {
  const { lang } = useLang();
  const navigate = useNavigate();
  return useCallback(
    (to, options) => navigate(withLang(lang, to), options),
    [lang, navigate]
  );
}
